import { RAIN_ARBI_CONTRACT_ADDRESS, RAIN_CONTRACT_ADDRESS, usdt_token } from "./Enviroment"

export const POOL_NOT_LIVE = 'Market Not Live'
export const POOL_ENDED = 'Market Ended'
export const POOL_STARTS_IN = 'Starts In'
export const ENDED = 'Ended'
export const OPEN = 'open'
export const POOL_ENDS_IN = 'Ends In'
export const POOL_OPEN = 'Market Open'
export const LIMIT_BUY = 'limitbuy'
export const MARKET_BUY = 'marketbuy'
export const TOKEN_USDT = 'USDT'
export const TOKEN_RAIN = 'RAIN'
export const TOKEN_BTC = 'BTC'
export const DEFAULT_TOKEN = 'Select Token'
export const DEFAULT_CHAIN = 'Select_Chain'
export const TOKEN_ETH = 'ETH'
export const TOKEN_USDC = 'USDC'
export const TOKEN_BNB = 'BNB'
export const USDT_UNIT = "mwei"
export const RAIN_UNIT = "ether"
export const CHAIN_BSC = 'BSC'
export const CHAIN_ARBITRUM = 'Arbitrum'
export const CHAIN_BITCOIN = 'bitcoin'
export const QR_CODE_SIZE = 220;
export const USDT_LOGO_SIZE = 40;
export const REFERRAL_POINTS = 1000;
export const TWITTER_POINTS = 500;
export const TWITTER_VALUE = 0;
export const PERCENTAGE_OF_POINTS = 0.025;
export const INVITE = "invite";
export const TIMEOUT = 2000;
export const WHITELISTING_CHECK_TIME = 2500;
export const PNL_CALCULATION_TIMEOUT = 5000;
export const DEPOSIT = "deposit";
export const WITHDRAW = "withdraw";
export const FOLLOW_TWITTER = "follow_twitter";
export const USDT_MOCK_VALUE = 0.2;
export const DISPUTED_WINNER_CHECK_TIME = 60000;
export const AQUA_WALLET_TIME_EXPIRE = 120000;
export const APPEAL_OPENED = "appeal-opened"
export const APPEAL_WINNER_CAlCULATED = "appeal-winner"
export const DISPUTE_TIME_EXTENDED = "dispute-time-extented"
export const SEARCH_MARKETS_DEBOUNCE = 800;
export const LIQUIDITY_DISPUTE_CREATION = 0.001; //0.1% of pool liquidity
export const MAX_LIQUIDITY_DISPUTE_CREATION = 1000; //maximum $1000
export const LIMIT_BUY_SELL_MIN_CAP = 1; //$
export const LIGHT_THEME = "light"
export const DARK_THEME = "dark"
export const EXPLORE_MARKET_ROUTE = '/explore-market'
export const NOTIFICATION_STATUS_UNREAD = "unread"
export const ALL_MARKETS = "All Markets"
export const UPCOMING_MARKETS = "Upcoming Markets"
export const LIVE = "Live"
export const NEW = "New"
export const WAITING_FOR_RESULT = "Trade Finalizing"
export const ALL = "All"
export const PENDING_FINALLIZATION = "Trading"
export const UNDER_DISPUTE = "Under Dispute"
export const UNDER_APPEAL = "Under Appeal"
export const DISPUTE_WINDOW_OPEN = "In Review"
export const APPEAL_WINDOW_OPEN = "In Evaluation"
export const CLOSED = "Closed"
export const CLOSING_SOON = "Closing Soon"
export const ENDED_MARKETS = "Ended Markets"
export const NONE = "Unclassified outcome"
export const NETWORK_FEES = "network fee "
export const ONE_MINUTE = 60000
export const RAIN_WALLET_ADDRESS = "0x453E5a52F3b1ca9Ba3659d2DEc7Db5b110c67A20"
export const APPEAL = "Appeal"
export const DISPUTE = "Dispute"
export const LEX_AI = "lex"
export const ORACLES = "oracle"
export const OLYMPUS_AI = "olympus-ai"
export const UNDER_DISPUTE_STATUS = "Under_Dispute"
export const RESOLVER = "resolver"
export const HISTORY_TYPE_MESSAGE = "message"
export const MARKET_VERSION = "v2"
export const FEATURE_BLOG_CATEGORY_ID = 7
export const BLOGS_PER_PAGE = 9
export const DISPUTER = "disputer"
export const APPEALER = "appealer"
export const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000"
export const PRICE_DECIMALS = 18
export const BUY = "buy"
export const SELL = "sell"
export const WHATSAPP = "whatsapp"
export const OTHER = "other"
export const EXCHANGE_LINKS = {
    MEXC: "https://www.mexc.com/exchange/RAIN_USDT",
    BINGX: "https://bingx.com/en/spot/RAINPROTOCOLUSDT",
    BITMART: "https://www.bitmart.com/en-US/trade/RAIN_USDT",
    GEMSTRADE: "https://www.gems.trade/trading/rainusdt",
    UNISWAP: "https://app.uniswap.org/positions/v3/arbitrum/4889371",
    DEXTOOLS: "https://www.dextools.io/token/rain",
    DEXSCREENER: `https://dexscreener.com/arbitrum/${RAIN_CONTRACT_ADDRESS}`,
    DEFILLAMA: "https://defillama.com/protocol/rain",
    CMC: "https://coinmarketcap.com/currencies/rain/",
    ARBISCAN: `https://arbiscan.io/token/${RAIN_ARBI_CONTRACT_ADDRESS}`,
    NANSEN: `https://app.nansen.ai/token-god-mode?chain=arbitrum&tab=transactions&tokenAddress=${RAIN_ARBI_CONTRACT_ADDRESS}`,
    COINGECKO: "https://www.coingecko.com/en/coins/rain"

};

export const marketFilterOptions = [
    ALL,
    NEW,
    LIVE,
    PENDING_FINALLIZATION,
    CLOSING_SOON,
    DISPUTE_WINDOW_OPEN,
    CLOSED,
];

export const getLanguageIcons = {
    Heb: "/assets/languagesicons/hebrew.svg",
    Jpn: "/assets/languagesicons/jap.svg",
    Itl: "/assets/languagesicons/italian.svg",
    Eng: "/assets/languagesicons/english.svg",
    Chi: "/assets/languagesicons/chinese.svg",
    Ger: "/assets/languagesicons/germany.svg",
    Arbc: "/assets/languagesicons/arabic.svg",
    Spn: "/assets/languagesicons/spanish.svg",
    Kor: "/assets/languagesicons/korean.svg",
};

export const getHistoryDescription = {
    "olympus-ai": "decided the winner.",
    "resolver": "decided the winner.",
    "lex": "reviewed and delivered the verdict",
    "oracle": "reviewed and finalized the verdict.",
    "appealer": "Created an appeal.",
    "creator": "responded to the Dispute.",
    "disputer": "Created a Dispute.",
};

export const getPointsRatio = {
    deposit: "2.5% of deposit amount",
    withdraw: "-2.5% of withdraw amount",
    trade: "2.5% of trade fee",
    add_liquidity: "2.5% of liquidity provided",
    open_market: "Total volume of market",
    referral_reward: "Referral reward",
    Joining_reward: "Joining reward",
    follow_twitter: "Twitter reward",
};

export const getPointsTitle = {
    deposit: "Deposit",
    withdraw: "Withdraw",
    trade: "Trade",
    add_liquidity: "Add liquidity",
    open_market: "Open market",
    referral_reward: "Referral reward",
    Joining_reward: "joining reward",
    follow_twitter: "Twitter reward",
};

export const getNotificationEvent = {
    POOL_END_REACHED: "Market Time Ended",
    POOL_CLOSED: "Market Closed",
    WINNER_DECIDED: "Winner Decided",
    DISPUTE_CREATED: "Dispute Created",
    DISPUTE_WINDOW_CLOSED: "Claim Opened",
    CLAIMS_OPENED: "Claims Opened",
    ORDER_FULFILLED: "Order Fulfilled",
    DISPUTE_WINNER_DECIDED: " Dispute Winner Decided",
    APPEAL_WINNER_DECIDED: " Appeal Winner Decided",
    APPEAL_CREATED: "Appeal Created",
};

export const CHAIN_TO_TOKEN_ADDRESSES = {
    ARBITRUM: {
        USDT: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
        USDC: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
        ETH: "0x0000000000000000000000000000000000000000"
    },
    BASE: {
        USDT: "0xfde4C96c8593536E31F229EA8f37b2ADa2699bb2",
        USDC: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
        ETH: "0x0000000000000000000000000000000000000000"
    },
    BSC: {
        USDT: "0x55d398326f99059fF775485246999027B3197955",
        USDC: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
        BNB: "0x0000000000000000000000000000000000000000"
    },
    BITCOIN: {
        BTC: "0x0000000000000000000000000000000000000000",
    },
    ETHEREUM: {
        ETH: "0x0000000000000000000000000000000000000000",
        USDC: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        USDT: "0xdAC17F958D2ee523a2206206994597C13D831ec7"
    }
}

export const AQUA_SWAP_TX_STATUS = {
    PENDING: "PENDING",
    DEPOSITED: "DEPOSITED",
    IN_SWAP: "IN_SWAP",
    FINALIZED: "FINALIZED",
    REFUNDED: "REFUNDED",
    COMPLETED: "COMPLETED"
}

export const aquaChains = [
    { key: DEFAULT_CHAIN, label: "Select Chain", icon: "" },
    { key: "Arbitrum", label: "Arbitrum", icon: "/assets/tokennew/arb.svg" },
    { key: "BASE", label: "Base", icon: "/assets/tokennew/base.svg" },
    { key: "BSC", label: "BSC", icon: "/assets/tokennew/bsc.svg" },
    { key: "Ethereum", label: "Ethereum", icon: "/assets/poll/eth.svg" },
    { key: "bitcoin", label: "Bitcoin", icon: "/assets/btc-icon.svg" },
];

export const aquaTokens = [
    { key: DEFAULT_TOKEN, label: DEFAULT_TOKEN, icon: "" },
    // { key: TOKEN_RAIN, label: TOKEN_RAIN, icon: "/assets/rain-icon.svg" },
    { key: TOKEN_BTC, label: TOKEN_BTC, icon: "/assets/btc-icon.svg" },
    { key: TOKEN_USDT, label: TOKEN_USDT, icon: "/assets/usdticon.png" },
    { key: TOKEN_USDC, label: TOKEN_USDC, icon: "/assets/usdc.svg" },
    { key: TOKEN_BNB, label: TOKEN_BNB, icon: "/assets/tokennew/bsc.svg" },
    { key: TOKEN_ETH, label: TOKEN_ETH, icon: "/assets/poll/eth.svg" },
];

export const lockedChainTokens = [TOKEN_RAIN, TOKEN_BTC];

export const CHAIN_TO_TOKEN_MIN_AMOUNT = {
    ARBITRUM: {
        USDT: "$5",
        USDC: "$5",
        ETH: "0.002 ETH"
    },
    BASE: {
        USDT: "$5",
        USDC: "$5",
        ETH: "0.002 ETH"
    },
    BSC: {
        USDT: "$5",
        USDC: "$5",
        BNB: "0.004 BNB"
    },
    BITCOIN: {
        BTC: "0.0002 BTC",
    },
    ETHEREUM: {
        ETH: "0.002 ETH",
        USDC: "$5",
        USDT: "$5"
    }
}

export const MIN_AMOUNT_PER_TOKEN = {
    USDT: 4,
    USDC: 4,
    ETH: 6,
    BNB: 6,
};

export const CLOSE_POOL_OPTIONS = {
    INSTANT: "INSTANT",
    AFTER_END: "AFTER_END",
    SCHEDULE: "SCHEDULE",
};

export const MARKET_START_DATE_TYPES = {
    CURRENT: "current",
    SPECIFIC: "specific",
};

export const GameState = {
    crashGame: "0"
};
export const TOKEN_NAME_TO_CONTRACT_ADDRESS = {
    RAIN: RAIN_ARBI_CONTRACT_ADDRESS,
    USDT: usdt_token,
};

export const WALLET_ORDER = [
    'MetaMask',
    'WalletConnect',
    'Binance Wallet',
    'Coinbase Wallet',
]
